import { ResourceTypeModifier } from './resourceTypeModifier';
import { Item } from './item';

export interface AddOns {
  resourceTypeModifiers: ResourceTypeModifier[];
  includedProducts: Item[];
  products: Item[];
}
